import React from 'react'
import { TextWrapper } from './style'
import { AutoResizeText } from 'shared-ui/utils'

const Text = React.memo(
  ({
    textalign,
    marginTop,
    marginBottom,
    text,
    fromchannels,
    tag = 'span',
    color,
    children,
    fromsettingpage,
    fromMultiModal,
    textDecoration,
    ml,
    fontSize,
    margin,
    lineHeight,
    fontWeight,
    position,
    cursor,
    padding,
    maxLines,
    ...rest
  }) => {
    const wrapperStyle = {}
    if (marginTop !== undefined) wrapperStyle.marginTop = marginTop
    if (marginBottom !== undefined) wrapperStyle.marginBottom = marginBottom
    const rawContent = children !== undefined ? children : text
    const content =
      typeof rawContent === 'string'
        ? rawContent.replace(/\\n/g, '\n')
        : Array.isArray(rawContent)
        ? rawContent.map(c => (typeof c === 'string' || typeof c === 'number' ? c : (c?.props?.children || ''))).join('')
        : (rawContent !== undefined && rawContent !== null ? String(rawContent) : '')

    const numericFontSize = typeof fontSize === 'number' ? fontSize : (parseFloat(String(fontSize || 14).replace(/[^0-9.]/g, '')) || 14)

    return (
      <TextWrapper
        fromchannels={fromchannels}
        as={tag}
        color={color}
        textalign={textalign}
        fromsettingpage={fromsettingpage}
        fromMultiModal={fromMultiModal}
        ml={ml}
        textDecoration={textDecoration}
        fontSize={fontSize}
        fontWeight={fontWeight}
        margin={margin}
        lineHeight={lineHeight}
        position={position}
        cursor={cursor}
        padding={padding}
        style={wrapperStyle}
        {...rest}
      >
        <AutoResizeText
          text={content}
          maxFontSize={numericFontSize}
          maxLines={maxLines}
          style={{
             whiteSpace: 'pre-wrap'
          }}
        />
      </TextWrapper>
    )
  }
)

export default Text
